import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable()
export class EmitService {
 
    private pacslistSubject = new Subject<any>();
    private pacsInfoSubject = new Subject<any>();
    private pacsFileUploadSubject = new Subject<any>();
    private addSubject = new Subject<any>();
    private addFinishSubject = new Subject<any>();
    private cripPatientSubject = new Subject<any>();
    private deletePatientSubject = new Subject<any>();
    private deleteFileSubject = new Subject<any>();

    sendDeleteFileMessage(message: string) {
        this.deleteFileSubject.next({ text: message });
    }

    clearDeleteFileMessage() {
        this.deleteFileSubject.next();
    }

    getDeleteFileMessage(): Observable<any> {
        return this.deleteFileSubject.asObservable();
    }


    sendPatientMessage(message: string) {
        this.deletePatientSubject.next({ text: message });
    }

    clearPatientMessage() {
        this.deletePatientSubject.next();
    }

    getPatientMessage(): Observable<any> {
        return this.deletePatientSubject.asObservable();
    }
    
    sendPacsListMessage(message: string) {
        this.pacslistSubject.next({ text: message });
    }

    clearPacsListMessage() {
        this.pacslistSubject.next();
    }

    getPacsListMessage(): Observable<any> {
        return this.pacslistSubject.asObservable();
    }

    sendPacsInfoMessage(message: string) {
        this.pacsInfoSubject.next({ text: message });
    }

    clearPacsInfoMessage() {
        this.pacsInfoSubject.next();
    }

    getPacsInfoMessage(): Observable<any> {
        return this.pacsInfoSubject.asObservable();
    }

    sendPacsFileUploadSubjectMessage(message: string) {
        this.pacsFileUploadSubject.next({ text: message });
    }

    clearPacsFileUploadSubjectMessage() {
        this.pacsFileUploadSubject.next();
    }

    getPacsFileUploadSubjectMessage(): Observable<any> {
        return this.pacsFileUploadSubject.asObservable();
    }
    sendAddSubjectSubjectMessage(message: string) {
        this.addSubject.next({ text: message });
    }

    clearAddSubjectSubjectMessage() {
        this.addSubject.next();
    }

    getAddSubjectSubjectMessage(): Observable<any> {
        return this.addSubject.asObservable();
    }

    sendAddFinishSubjectMessage(message: string) {
        this.addFinishSubject.next({ text: message });
    }

    clearAddFinishSubjectMessage() {
        this.addFinishSubject.next();
    }

    getAddFinishSubjectMessage(): Observable<any> {
        return this.addFinishSubject.asObservable();
    }
    
    sendCripPatientSubjectMessage(message: string) {
        this.cripPatientSubject.next({ text: message });
    }

    clearCripPatientSubjectMessage() {
        this.cripPatientSubject.next();
    }

    getCripPatientSubjectMessage(): Observable<any> {
        return this.cripPatientSubject.asObservable();
    }
}